// Switching the active business has to behave identically wherever it is
// triggered — the top-bar switcher and any in-page "runs for" selector both
// write through here, so the two can never drift apart. A null/empty id is the
// admin "all businesses" state.
export async function applyActiveBusinessSelection({
  uid,
  userProfile,
  setUserProfile,
  updateProfileInFirestore,
  businessId,
} = {}) {
  const normalizedId = String(businessId || "").trim() || null;
  const normalizedUid = String(uid || "").trim();
  if (!normalizedUid) return normalizedId;

  setUserProfile({
    ...(userProfile || {}),
    uid: normalizedUid,
    primaryBusinessId: normalizedId,
  });

  try {
    await updateProfileInFirestore(normalizedUid, {primaryBusinessId: normalizedId});
  } catch (error) {
    // The in-memory switch already happened; losing the persisted preference
    // is not worth failing the interaction over.
    console.warn("Failed to persist current business selection:", error);
  }
  return normalizedId;
}

export async function loadBusinessSwitcherRows({
  uid,
  isAdmin = false,
  listAllBusinesses,
  listBusinessesForUser,
} = {}) {
  if (isAdmin) {
    return listAllBusinesses();
  }
  if (!uid) return [];
  return listBusinessesForUser(uid);
}

export function filterVisibleBusinessSwitcherRows({
  rows = [],
  isAdmin = false,
  isIndividualUser = false,
  uid = "",
} = {}) {
  const normalizedUid = String(uid || "").trim();
  const allRows = Array.isArray(rows) ? rows : [];
  if (!isIndividualUser || isAdmin) return allRows;
  return allRows.filter((entry) => {
    const ownerUid = String(entry?.ownerUid || entry?.createdByUid || "").trim();
    return ownerUid !== normalizedUid;
  });
}
